module.exports = __webpack_public_path__ + "img/Next.78980dc1.svg";